import { ActionSubjectCached, runAction } from "../action";
import { ColorMode } from "shared";

export const themeAction = {
	setColorMode: new ActionSubjectCached<ColorMode>()
};

export const setColorMode = (mode: ColorMode) => runAction(themeAction.setColorMode, () => mode);
